// WebstoreAdmin.jsx
import React, { useState } from 'react';
import WebstoreAdminOrders from './WebstoreAdminOrders';
import WebstoreAdminUsers from './WebstoreAdminUsers';
import WebstoreAdminServices from './WebstoreAdminServices';
import WebstoreAdminChat from './WebstoreAdminChat'; 
import Helmet from 'react-helmet'
const WebstoreAdmin = () => {
  const [activeTab, setActiveTab] = useState('orders');

  return (
    <div className="webstore-admin-wrapper">
      <Helmet>
        <title>Webstore | Dashboard</title>
        <meta name="description" content="Webstore | Dashboard" />
        <meta property="og:title" content="Webstore | Dashboard" />
      </Helmet>
      <div className="admin-header">
        <h2>Webstore Admin Panel</h2>
        <div className="admin-tabs">
          <button
            className={activeTab === 'orders' ? 'active' : ''}
            onClick={() => setActiveTab('orders')}
          >
            Orders
          </button>

            <button
              className={activeTab === 'chat' ? 'active' : ''}
              onClick={() => setActiveTab('chat')}
            >
              Chat
            </button>

          <button
            className={activeTab === 'users' ? 'active' : ''}
            onClick={() => setActiveTab('users')}
          >
            Users
          </button>

          <button
            className={activeTab === 'services' ? 'active' : ''}
            onClick={() => setActiveTab('services')}
          >
            Services
          </button>

        </div>
      </div>

      <div className="admin-content">
        {activeTab === 'orders'    && <WebstoreAdminOrders />}
        {activeTab === 'chat'      && <WebstoreAdminChat />}
        {activeTab === 'users'     && <WebstoreAdminUsers />}
        {activeTab === 'services'  && <WebstoreAdminServices />}
      </div>
    </div>
  );
};

export default WebstoreAdmin;
